var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'is-mobile': _vm.$store.state.mobile },attrs:{"id":"app"}},[_c('BaseBaseAccess'),_c('Navigation'),_c('router-view'),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.nav)?_c('Menu'):_vm._e()],1),_c('transition',{attrs:{"name":"fade"}},[(_vm.$store.state.showModal)?_c('Modal'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1289d5a4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/base/app.pug
// module id = b39o
// module chunks = 2